import './Loader.scss';
import { useEffect, useState } from 'react';
import brandLogos from '../../assets/Tri-Brand-Maroline-logos-Framed.svg';
import accoladeLogo from '../../assets/Logo-Accolade-light-2.png';

interface LoaderProps {
  variant?: 'fullscreen' | 'overlay';
}

export const Loader: React.FC<LoaderProps> = ({ variant = 'overlay' }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Small delay to ensure CSS transition works
    const timer = setTimeout(() => setIsActive(true), 50);
    return () => clearTimeout(timer);
  }, []);
  if (variant === 'fullscreen') {
    return (
      <div className={`loader-fullscreen ${isActive ? 'active' : ''}`}>
        <div className="loader-fullscreen__container">
          <img src={accoladeLogo} alt="Accolade Logo" className="loader-fullscreen__accolade" />
          <p className="loader-fullscreen__text">BY</p>
          <img src={brandLogos} alt="Brand Logos" className="loader-fullscreen__brands" />
        </div>
      </div>
    );
  }

  // Overlay loader
  return (
    <div className="loader-overlay">
      <div className="loader-overlay__spinner"></div>
    </div>
  );
};
